import React from 'react'
import {Card, Accordion} from 'react-bootstrap'

function PoemItem({title, text}) {
    return(
        <Card className='mb-4'>
            <Card.Body>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <Card.Title style={{marginBottom: 0}}>{title}</Card.Title>
                        </Accordion.Header>
                        <Accordion.Body style={{ whiteSpace: 'pre-line' }}>
                            {text}
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Card.Body>
        </Card>
    )
}

export default PoemItem